/**
 * 获取车型信息
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { request } from './request';
export var apiList = {
    /** 根据频道获取当前频道下的所有广告id first */
    getAllChannelIdApi: '//www.58che.com/light/ajax_index/ad',
    /** 根据广告id获取当前的所有广告具体信息 second */
    getAllAdvInfoApi: '//spread.58che.com/list/getbychannel',
    /** 发送短信验证码 */
    sendMsCodeApi: '//service.58che.com/unify/v1/sendcode/',
    /** 通用询价接口 */
    commonAskPriceApi: '//service.58che.com/unify/v1/suborder/',
    /** 获取车型信息 */
    getProdInfoApi: '//service.58che.com/unify/v1/popup/',
    /** 获取是否需要默认勾选隐私协议和是否需要显示获取验证码 */
    getIsNeedMsgCodeApi: '//service.58che.com/unify/v1/toast/',
};
/**
 * 获取是否需要默认勾选隐私协议和显示验证码
 * @param params
 * @returns
 */
export var getIsNeedMsgCode = function (params) {
    return request(apiList.getIsNeedMsgCodeApi, __assign({}, params), 'jsonp');
};
/**
 * 获取车型信息
 * @param params
 * @returns
 */
export var getProdInfos = function (params) {
    return request(apiList.getProdInfoApi, __assign({}, params), 'jsonp');
};
/**
 * 询价接口
 * @param params
 * @returns
 */
export var sendAskPrice = function (params) {
    return request(apiList.commonAskPriceApi, __assign({}, params), 'json', {
        method: 'post',
        isCors: true,
        paramsType: 'formdata',
    });
};
/**
 * 发送短信验证码接口
 * @param params
 * @returns
 */
export var sendMsgCode = function (params) {
    return request(apiList.sendMsCodeApi, __assign({}, params), 'jsonp');
};
/**
 * 获取所有的广告信息，根据频道名称
 * @param params
 * @returns
 */
export var getAllAdvInfo = function (params) {
    return request(apiList.getAllAdvInfoApi, __assign({}, params), 'jsonp');
};
/**
 * 根据广告渠道来源获取当前的频道和当前频道下的广告id
 */
export var getAllAdvId = function (params) {
    return request(apiList.getAllChannelIdApi, __assign({}, params), 'jsonp');
};
